import { NewsArticle } from '@/lib/news';
import NewsCard from './NewsCard';

interface NewsListProps {
  articles: NewsArticle[];
  isLoading?: boolean;
}

const NewsList = ({ articles, isLoading = false }: NewsListProps) => {
  if (isLoading) {
    return (
      <div className="mt-6">
        <div className="animate-pulse space-y-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-gray-100 h-32 rounded-lg"></div>
          ))}
        </div>
      </div>
    );
  }

  if (!articles.length) {
    return null;
  }

  return (
    <div className="mt-6">
      <h2 className="text-2xl font-semibold mb-4">Related News</h2>
      <div className="space-y-4">
        {articles.map((article, index) => (
          <NewsCard key={index} article={article} />
        ))}
      </div>
    </div>
  );
};

export default NewsList; 